import { IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import * as React from 'react';
import { Map as MapRef } from '@cian/frontend-newbuilding-map-component/es/components/Map/Map';
import { IGeoObject } from '@cian/frontend-newbuilding-map-component/es/types';
import { IControl } from '@cian/frontend-newbuilding-map-component/es/types/control';
import { TRefWrapper } from '../../Scrolling';

export interface ICoordinates {
  /** Широта **/
  lat: number;
  /** Долгота **/
  lng: number;
}

export interface ICoordinatesResponse {
  /** Широта **/
  lat: number;
  /** Долгота **/
  lon: number;
}

export enum EInfrastructureType {
  /** Дом, по которому сформирован отчет **/
  Main = 'main',
  /** Поликлиники **/
  Clinic = 'clinic',
  /** Продуктовые магазины **/
  Grocery = 'grocery',
  /** Детские сады **/
  Nursery = 'nursery',
  /** Школы **/
  School = 'school',
}

export interface IInfrastructureType {
  /** Название типа для блока инфраструктуры **/
  title: string;
  /** Тип инфраструктуры **/
  type: EInfrastructureType;
}

export interface IInfrastructureItemResponse {
  /** Координаты пина на карте **/
  coordinates: ICoordinatesResponse;
  /** id **/
  id: string;
  /** ЦИАН id **/
  cianId: string;
  /** Название объекта **/
  title: string;
  /** Дистанция */
  distance: string;
}

export interface IInfrastructureResponse {
  /** Категория объекта инфраструктуры **/
  category: EInfrastructureType;
  /** Название категории для блока инфраструктуры **/
  title: string;
  /** Айтемы инфраструктуры **/
  items: IInfrastructureItemResponse[];
}

export interface IInfrastructureItem {
  /** Координаты пина на карте **/
  coordinates: ICoordinates;
  /** id **/
  id: string;
  /** Время пешком до объекта **/
  timeWalk: number;
  /** Название объекта **/
  title: string;
  /** Тип объекта инфраструктуры **/
  type: EInfrastructureType;
  /** Дистанция */
  distance: string;
  /** Адрес */
  address?: string | null;
}

export interface IInfrastructure {
  geoObjectsData: Array<{
    geoObject: IMapGeoObject;
    infrastructureItem: IInfrastructureItem | null;
  }>;
}

export interface IInfrastructureProps {
  isMapLoaded: boolean;
  currentTypes: string[];
  metroStations: IMetroStation[];
  roads: IRoad[];
  controls: IControl[];
  suggestPosition?: 'top' | 'bottom';
  mapRef: React.MutableRefObject<MapRef | null>;
  infrastructureByYearRef: React.MutableRefObject<Map<number, IInfrastructure>>;
  centeredCoordinates: ICoordinates;
  infrastructureTypes: IInfrastructureType[] | null;
  setInfrastructureType: (types: string[]) => void;
  handleMapLoaded: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onGeoObjectsFetch: () => Promise<any[]>;
}

export interface IGeoObjectBalloonProps {
  onBalloonHtmlFirstFetch: (item: IGeoObject) => Promise<string>;
  onBalloonOpen: (item: IGeoObject) => void;
}

export enum EGeoType {
  /** Въезд на шоссе **/
  EntryIntoRoad = 'entryIntoRoad',
  /** ЖД станция **/
  RailwayStation = 'railwayStation',
  /** Шоссе **/
  Road = 'road',
  /** Метро **/
  Underground = 'underground',
}

export enum ETravelType {
  /** На автомобиле **/
  ByCar = 'byCar',
  /** Пешком **/
  ByFoot = 'byFoot',
}

export interface IMetroStation {
  name: string;
  distance: number;
  geoId: number;
  geoType: EGeoType;
  travelTime: number;
  travelType: ETravelType;
  color: string;
}

export interface IRoad {
  distance: string;
  geoId: number;
  name: string;
}

export interface IInfrastructureContainerLoadProps {
  refWrapper: TRefWrapper;
}
